var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('loader'),_vm._v(" "),_c('pwa-update'),_vm._v(" "),_c('notifications'),_vm._v(" "),_c('page-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }